import type {
    SearchGoogleDriveAssessmentFilters,
    SearchGoogleMailboxAssessmentFilters,
    SearchMailboxesAssessmentFilters,
    SearchOneDriveAssessmentFilters,
    SearchSharePointAssessmentFilters,
    SearchTeamsAssessmentFilters,
    SearchUsersAssessmentFilters
} from "./api/types.ts";

export const Routes = {
    root: "/migrate",
    assessment: "/migrate/assessment",
    missingSharegateLicense: "/migrate/missing-sharegate-license",
    microsoft: {
        wizard: "/migrate/microsoft",
        tenantAccessRequest: "/migrate/microsoft/tenant-access-request",
        assessment: "/migrate/microsoft/assessment",
        overview: "/migrate/microsoft/assessment/overview",
        sharepoint: "/migrate/microsoft/assessment/sharepoint",
        onedrive: "/migrate/microsoft/assessment/onedrive",
        teams: "/migrate/microsoft/assessment/teams",
        users: "/migrate/microsoft/assessment/users",
        exchange: "/migrate/microsoft/assessment/exchange",
        filtered: {
            teams: (filter: SearchTeamsAssessmentFilters) => `${Routes.microsoft.teams}?filter=${filter}`,
            sharepoint: (filter: SearchSharePointAssessmentFilters) =>
                `${Routes.microsoft.sharepoint}?filter=${filter}`,
            onedrive: (filter: SearchOneDriveAssessmentFilters) => `${Routes.microsoft.onedrive}?filter=${filter}`,
            users: (filter: SearchUsersAssessmentFilters) => `${Routes.microsoft.users}?filter=${filter}`,
            exchange: (filter: SearchMailboxesAssessmentFilters) => `${Routes.microsoft.exchange}?filter=${filter}`
        }
    },
    google: {
        wizard: "/migrate/google",
        assessment: "/migrate/google/assessment",
        overview: "/migrate/google/assessment/overview",
        drives: "/migrate/google/assessment/drives",
        mailboxes: "/migrate/google/assessment/mailboxes",
        filtered: {
            drives: (filter: SearchGoogleDriveAssessmentFilters) => `${Routes.google.drives}?filter=${filter}`,
            mailboxes: (filter: SearchGoogleMailboxAssessmentFilters) => `${Routes.google.mailboxes}?filter=${filter}`
        }
    }
};

export const WizardUrl = `${window.location.origin}${Routes.microsoft.wizard}`;
export const RequestAccessUrl = `${window.location.origin}${Routes.microsoft.tenantAccessRequest}`;
export const LoginHintQueryParam = "login_hint";

// @TODO remove legacy values once UpdatedMigrateAssessmentThresholdsEnabled is removed
export const MicrosoftAssessmentThresholds = {
    oneDrive: {
        largeContentSizeGb: { legacy: 10, actual: 100 },
        manyFilesCount: 10000,
        inactiveDays: 180
    },
    sharePoint: {
        largeContentSizeGb: { legacy: 10, actual: 100 },
        manyFilesCount: { legacy: 10000, actual: 4000 },
        inactiveDays: 180,
        tenantSiteCount: 500
    },
    teams: {
        largeContentSizeGb: 10,
        manyMembersCount: { legacy: 50, actual: 25 },
        inactiveDays: 180
    },
    mailbox: {
        largeContentSizeGb: 10
    }
} as const;

type AssessmentThreshold<T> = { legacy: T; actual: T };
export const pickAssessmentThreshold = <T>(threshold: AssessmentThreshold<T>, updatedEnabled: boolean): T =>
    updatedEnabled ? threshold.actual : threshold.legacy;
